import { motion } from "framer-motion";
import { Calculator, Users } from "lucide-react";
import { Button } from "../ui/button";
import { Badge } from "../ui/badge";

/**
 * ROICalculatorSection Component - Opens calculator modal
 */
export default function ROICalculatorSection({ onOpenCalculator }) {
  return (
    <section className="py-24 px-4 sm:px-6 lg:px-8">
      <div className="max-w-4xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="glass-card rounded-2xl p-12 border border-white/10 text-center"
        >
          <Badge className="mb-6 bg-green-500/20 text-green-400 border-green-500/30">
            <Calculator className="w-3 h-3 mr-1" />
            ROI Calculator
          </Badge>
          
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold mb-4 tracking-tighter">
            How Much Could <span className="gradient-text">You Save?</span>
          </h2>
          
          <p className="text-lg text-muted-foreground mb-8 max-w-xl mx-auto">
            Most businesses save 60-90% on marketing costs with YASNO. Calculate your 
            exact savings in 30 seconds.
          </p>

          <Button 
            size="lg" 
            className="bg-green-500 hover:bg-green-600 text-white px-8 py-6 text-lg"
            onClick={onOpenCalculator}
          >
            <Calculator className="w-5 h-5 mr-2" />
            Calculate Your Savings
          </Button>

          <div className="flex items-center justify-center gap-2 mt-6 text-sm text-muted-foreground">
            <Users className="w-4 h-4" />
            <span>Join 1,245+ companies who switched and saved</span>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
